// extracted by mini-css-extract-plugin
module.exports = {"section":"Main_section__OI7Ck","searchWrapper":"Main_searchWrapper__mlmEN"};